import { hashKey, useMutation, useQueryClient } from '@tanstack/react-query';

import { type DeleteChannelMarkupV2Response, deleteChannelMarkupV2 } from '~/services/PromoService';

import { channelMarkupV2QueryKeys } from './useGetChannelMarkupV2ById';

export function useDeleteChannelMarkupV2() {
  const queryClient = useQueryClient();
  return useMutation<DeleteChannelMarkupV2Response, Error, string>({
    mutationFn: (channelMarkupId) => deleteChannelMarkupV2(channelMarkupId),
    onSuccess: (_data, channelMarkupId) => {
      const deletedDetailHash = hashKey(channelMarkupV2QueryKeys.detail(channelMarkupId));
      // The edit page may still be observing the deleted markup until it navigates away.
      // Mark it stale without refetching so it doesn't request a 404 before the redirect.
      queryClient.invalidateQueries({
        queryKey: channelMarkupV2QueryKeys.detail(channelMarkupId),
        refetchType: 'none',
      });
      queryClient.invalidateQueries({
        queryKey: channelMarkupV2QueryKeys.all,
        predicate: (query) => query.queryHash !== deletedDetailHash,
      });
    },
  });
}
